module.exports = __webpack_public_path__ + "static/psyche_icon-9cf21d9c9e63201754c7dae11419390d.svg";